import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { EMPTY } from "rxjs";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { ScrollerModule } from "primeng/scroller";
import { Popover, PopoverModule } from "primeng/popover";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ItemsSecurity } from "../../../../core/models/samplePO/details/itemsSecurity";
import { CommonModule } from "@angular/common";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { Address } from "../../../../core/models/shared/address";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";

@UntilDestroy()
@Component({
  selector: "jni-customer-account",
  templateUrl: "./customer-account.component.html",
  styleUrls: ["./customer-account.component.scss"],
  imports: [
    TableModule,
    ScrollerModule,
    PopoverModule,
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
  ],
})
export class CustomerAccountComponent implements OnInit {
  public customerVendor$ = new Subject<string>();
  customerLists: ClientSearchList[] = [];
  showSmallLoader = false;

  customerBillToObject!: ClientSearchList;
  @Input() customerAccountNumber = "";
  selectedAccountNumber = "";
  @Input() newSalesOrderCase = false;

  storesField = [
    {
      id: 1,
      name: "REDHAT",
      clientAccNumber: "81004914",
      clientPartyNumber: "PTY000019712",
    },
    {
      id: 2,
      name: "BOOZALLEN",
      clientAccNumber: "81015306",
      clientPartyNumber: "PTY000037130",
    },
  ];

  userRole = 0;
  enumUserRole = UserRole;
  productSecurity = {} as ItemsSecurity;

  @Input() parent!: FormGroup;
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Input() formErrors!: Record<string, string>;
  @Output() validationErrorEvent = new EventEmitter();
  @Output() clearShipToEvent = new EventEmitter();
  @Output() getBuyerEvent = new EventEmitter();
  @Output() getProgramEvent = new EventEmitter<string>();
  @Input() orderType = "";
  @Output() patchValueInCurrencyFieldEvent = new EventEmitter<string>();
  @Output() customerInventoryDefaultsEvent = new EventEmitter<{
    storeD365: string | null | undefined;
    warehouseD365: string | null | undefined;
    ownerD365: string | null | undefined;
  }>();

  constructor(
    private _customerAccountService: CustomerAccountService,
    private _samplepoListingService: SamplepoListingService,
    private _loginService: UserManagementService
  ) {}

  ngOnInit(): void {
    if (this.orderType === "inventory-sales")
      this.parent.get(["orderHeader", "customerIdValid"])?.disable();
    this.getUserProfile();
    this.supportRoles();
    this.searchCustomerName();
    const customerAccount = this.parent.get("orderHeader.customerId")?.value;
    if (customerAccount) {
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(customerAccount)
        .subscribe(res => {
          if (res?.data && res.data?.length > 0) {
            const clientObj = res.data[0];
            this.selectedAccountNumber = clientObj.clientAccount;
            this.clearInvoiceEmails();
            this.patchValueInCustomerAccount(this.selectedAccountNumber);
            this.customerBillToObject = clientObj;
            this.customerBillToObjectEvent.emit(this.customerBillToObject);
            if (clientObj.clientAccount != "") {
              this.deliveryAddress[1].status = false;
              this.deliveryAddress[2].status = false;
            } else {
              this.deliveryAddress[1].status = true;
              this.deliveryAddress[2].status = true;
            }
            this.patchValueInCustomerNameAndTelephoneField(clientObj);
            this.patchValueInCustomerAccountField(clientObj);
            this.patchValueInCustomerAddressField();
          }
        });
    }
  }
  onCustomerSearchOpenToggle(
    mydrop: Popover,
    event: Event,
    target: HTMLElement
  ) {
    const eventTarget = event.target as HTMLInputElement;
    mydrop.show(event, target);
    if (eventTarget.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  searchCustomerName() {
    this.customerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.smallLoaderEvent.emit(true);
          }
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            if (this.orderType === "inventory-sales") {
              if (
                this.productSecurity &&
                Object.keys(this.productSecurity).length
              ) {
                if (this.productSecurity.redHat) {
                  this.customerLists = res.data.filter(
                    (x: ClientSearchList) =>
                      x.clientAccount ==
                      this.storesField.find(x => x.name === "REDHAT")
                        ?.clientAccNumber
                  );
                }

                if (this.productSecurity.boozAllen) {
                  const boozClient = res.data.filter(
                    (x: ClientSearchList) =>
                      x.clientAccount ==
                      this.storesField.find(x => x.name === "BOOZALLEN")
                        ?.clientAccNumber
                  );
                  this.customerLists.push(...boozClient);
                }
              }
            } else {
              this.customerLists = res.data;
            }
          }
          this.smallLoaderEvent.emit(false);
        },
        error: () => {
          this.smallLoaderEvent.emit(false);
        },
      });
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.selectedAccountNumber = event.clientAccount;
    this.clearInvoiceEmails();
    this.patchValueInCustomerAccount(this.selectedAccountNumber);
    this.customerBillToObject = event;
    this.customerBillToObjectEvent.emit(this.customerBillToObject);
    if (event.clientAccount != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
    this.patchValueInCustomerNameAndTelephoneField(event);
    this.patchValueInCustomerAccountField(event);
    this.patchValueInCustomerAddressField();
    if (this.newSalesOrderCase) {
      this.patchValueInCurrencyFieldEvent.emit(event.currencyD365);
    }

    if (this.orderType === "inventory-sales") {
      this.customerInventoryDefaultsEvent.emit({
        storeD365: event.storeD365,
        warehouseD365: event.warehouseD365,
        ownerD365: event.ownerD365,
      });
    }

    clientProspetToggle.hide();
  }

  patchValueInCustomerAccount(accountNumber: string) {
    this.parent.patchValue({
      orderHeader: {
        customerId: accountNumber,
        customerIdValid: accountNumber,
      },
    });

    this.getBuyerEvent.emit();
    this.getProgramEvent.emit(accountNumber);
  }

  patchValueInCustomerAddressField() {
    this._customerAccountService
      .getCustomerAddressByPartyNumber(
        this.customerBillToObject?.partyNumber,
        this.customerBillToObject?.clientAccount
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            (x: Address) =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );

          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          } else {
            this.patchValuesInCustomerFormAddressField("");
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const keyboardEvent = event as KeyboardEvent;
    const val = event.target as HTMLInputElement;
    if (keyboardEvent.key.toLowerCase() === "tab") {
      const buyerName = val.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(buyerName)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (this.orderType === "inventory-sales") {
              if (
                this.productSecurity &&
                Object.keys(this.productSecurity).length
              ) {
                if (this.productSecurity.redHat) {
                  this.customerLists = res.data.filter(
                    x =>
                      x.clientAccount ==
                      this.storesField.find(x => x.name === "REDHAT")
                        ?.clientAccNumber
                  );
                }

                if (this.productSecurity.boozAllen) {
                  const boozClient = res.data.filter(
                    x =>
                      x.clientAccount ==
                      this.storesField.find(x => x.name === "BOOZALLEN")
                        ?.clientAccNumber
                  );
                  this.customerLists.push(...boozClient);
                }
              }
            } else {
              this.customerLists = res.data;
            }
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
              //this.clearShipToEvent.emit();
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });

      // const countryList = this.countryRegionList.filter(
      //   (x) =>
      //     x.countryRegionD365
      //       ?.toLowerCase()
      //       ?.includes(countryValue.toLowerCase()) ||
      //     x.currencyCodeD365
      //       ?.toLowerCase()
      //       ?.includes(countryValue.toLowerCase())
      // );
    }
  }

  supportRoles() {
    this._samplepoListingService
      .supportRoles()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.productSecurity = res.data;
          this.updateProductSecurityAndRole();
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
        this.updateProductSecurityAndRole();
      });
  }

  updateProductSecurityAndRole() {
    if (this.userRole !== this.enumUserRole.Admin) {
      if (this.productSecurity && Object.keys(this.productSecurity).length) {
        this.parent.get(["orderHeader", "customerIdValid"])?.enable();
      }
    } else if (this.userRole === this.enumUserRole.Admin) {
      this.parent.get(["orderHeader", "customerIdValid"])?.enable();
    }
  }

  patchValueInCustomerNameAndTelephoneField(clientObj: ClientSearchList) {
    this.parent.patchValue({
      customerAddress: {
        name: clientObj.organizationNameD365,
        telephone: clientObj.locator === null ? "" : clientObj.locator,
        billingLocationD365: clientObj.billingLocationD365,
        billingAttentionD365: clientObj.billingAttentionD365,
      },
    });
  }

  patchValueInCustomerAccountField(clientObj: ClientSearchList) {
    this.parent.patchValue({
      orderHeader: {
        accountNumberD365: clientObj.clientAccount,
      },
    });
  }

  clearClearForm() {
    this.parent.patchValue({
      customerAddress: {
        name: "",
        address: "",
        telephone: "",
        billingLocationD365: "",
        billingAttentionD365: "",
      },
    });
  }

  patchValuesInCustomerFormAddressField(address: string) {
    this.parent.patchValue({
      customerAddress: {
        address: address,
      },
    });
  }

  clearInvoiceEmails() {
    (this.parent.get("invoicedEmails") as FormArray).clear();
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }
}
